export default "__VITE_ASSET__CBCZmVze__"